import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners
} from '@angular/core';

import {
  provideRouter,
  withInMemoryScrolling
} from '@angular/router';

import {
  provideHttpClient
} from '@angular/common/http';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {

  providers: [

    provideBrowserGlobalErrorListeners(),

    provideRouter(

      routes,

      withInMemoryScrolling({

        anchorScrolling: 'enabled',

        scrollPositionRestoration: 'enabled'

      })

    ),

    provideHttpClient()

  ]

};